/**
 * 查看菜单
 * @author 3173
 * @date 2020-4-2
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
import { Row, Col, Spin } from 'antd'
let { WizModal, WizComponent, WizForm, WizCheckbox,WizButton } = component_tool;
const {WizContainer, WizReduxTemplate} = framework_tool;
let { $$, checkStrLength } = utils_tool;


class LookQuestionType extends WizContainer {

  componentName = 'LookQuestionType';

  constructor(props) {
    super(props);
    this.state = {
    }
  }
  /**
   * modal框的确定按钮触发
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = (data) => {
  };
  _onCancel(){
  }

  static defaultProps = {
    _ok: this._ok
  };
  render() {
    const { record, type } = this.props;
    const disabled = true
    let menuElements = [];
    if (record && record.menuElements && record.menuElements instanceof Array) {
      record.menuElements.forEach(element => {
        menuElements.push({ codeName: element.name, code: element.id })
      });
    }

    const columns = [
      {
        title: "分类名称",
        name: "name",
        dataIndex: "name",
        formItem: {
          initialValue: record.name,
          disabled
        },
      },
      ['1', '2', 1, 2].indexOf(type) !== -1 ? {
        title: "分类编码",
        name: "code",
        dataIndex: "code",
        formItem: {
          initialValue: record.code,
          disabled
        },
      } : null,
      {
        title: "上级分类",
        name: "parentName",
        dataIndex: "parentName",
        formItem: {
          placeholder: ' ',
          initialValue: record.parentName,
          disabled
        },
      },
      {
        title: "管理权限",
        name: "targetScope",
        dataIndex: "targetScope",
        formItem: {
            type: 'textarea',
            placeholder: ' ',
          initialValue: record.targetScope,
          disabled
        },
      },
      {
        title: "使用权限",
        name: "targetScope",
        dataIndex: "targetScope",
        formItem: {
            type: 'textarea',
            placeholder: ' ',
          initialValue: record.targetScope,
          disabled
        },

      },
      {
        title: "类型",
        name: "modes",
        dataIndex: "modes",
        dict: [
          { code: 0, codeName: '考试' },
          { code: 1, codeName: '练习' },
        ],
        formItem: {
            type: 'checkbox',
            placeholder: ' ',
          initialValue: record.modes,
          disabled
        },

      },
    ].filter(item => !!item)



    const formProps = {
      ref: 'form',
      columns,
      onSubmit: () => { },
      record,
      preview: false,
      footer: <div/>,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },

    };


    return (
<div>
      <WizForm {...formProps} />
      <Row>
            <Col span={22} />
            <Col span={2}>
              <WizButton type="primary" onClick={() => {
                this.props && this.props.changeModal(false)
              }}>确定</WizButton>
            </Col>
          </Row></div>

    );
  }
}

const mapStateToProps = (state, ownProps) => {
  };

  const options = {withRef: true};

  export default connect(mapStateToProps, null, null, options)(LookQuestionType);


